var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('h1',[_vm._v(_vm._s(_vm.pageContent.title))]),_c('a',{staticClass:"back-button",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v(" Back ")]),_c('div',{staticClass:"page-content-content",domProps:{"innerHTML":_vm._s(_vm.pageContent.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }